'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getLinePointsOfInterest = exports.getVisibleConnectionPoint = exports.getEdgeOriginAndRect = exports.isLineEdgeSnapped = exports.getUnsnappedCoordinates = exports.enlargeLine = exports.getLineDistance = exports.getEdgePosition = exports.isEndEdge = exports.isStartEdge = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Utils


// Geometry


// Constants


var _immutableHelper = require('../../../common/utils/immutableHelper');

var _rect = require('../../../common/maths/geometry/rect');

var rectLib = _interopRequireWildcard(_rect);

var _point = require('../../../common/maths/geometry/point');

var pointLib = _interopRequireWildcard(_point);

var _bezierUtil = require('../../../common/maths/geometry/bezierUtil');

var _lineControlPointUtil = require('./lineControlPointUtil');

var _lineConstants = require('../../../common/lines/lineConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var isStartEdge = exports.isStartEdge = function isStartEdge(edge) {
    return edge === _lineConstants.LINE_EDGE.start;
};
var isEndEdge = exports.isEndEdge = function isEndEdge(edge) {
    return edge === _lineConstants.LINE_EDGE.end;
};

var getEdgePosition = exports.getEdgePosition = function getEdgePosition(lineEdge) {
    return pointLib.getPoint((0, _immutableHelper.prop)('x', lineEdge), (0, _immutableHelper.prop)('y', lineEdge));
};

var getLineDistance = exports.getLineDistance = function getLineDistance(_ref) {
    var start = _ref.start,
        end = _ref.end;

    var startPoint = getEdgePosition(start);
    var endPoint = getEdgePosition(end);
    return pointLib.getDistance(startPoint, endPoint);
};

var enlargeLine = exports.enlargeLine = pointLib.moveFrom;

var getUnsnappedCoordinates = exports.getUnsnappedCoordinates = function getUnsnappedCoordinates(lineEdge, gridSize) {
    return pointLib.scale(gridSize, getEdgePosition(lineEdge));
};

var isLineEdgeSnapped = exports.isLineEdgeSnapped = function isLineEdgeSnapped(lineEdge) {
    return lineEdge && lineEdge.get('snapped');
};

var getConnectedElementMeasurements = function getConnectedElementMeasurements(_ref2) {
    var lineEdge = _ref2.lineEdge,
        measurementsMap = _ref2.measurementsMap;

    if (!isLineEdgeSnapped(lineEdge)) return null;
    var connectedElementId = lineEdge.get('elementId');
    var connectedElementMeasurements = measurementsMap.get(connectedElementId);
    return connectedElementMeasurements && connectedElementMeasurements.toJS();
};

/**
 * Gets the translation from the top left point of the line element to the top left point of the connected element.
 */
var getConnectedElementCoordinateTranslation = function getConnectedElementCoordinateTranslation(_ref3) {
    var connectedElementPosition = _ref3.connectedElementPosition,
        lineElementPosition = _ref3.lineElementPosition;
    return pointLib.difference(lineElementPosition.toJS(), connectedElementPosition.toJS());
};

var getScaledConnectedElementCoordinateTranslation = function getScaledConnectedElementCoordinateTranslation(_ref4) {
    var connectedElementPosition = _ref4.connectedElementPosition,
        lineElementPosition = _ref4.lineElementPosition,
        gridSize = _ref4.gridSize;

    if (!connectedElementPosition) return null;

    // The translation required to bring the connected element's dimensions into the line element's coordinate system
    var lineElementCoordinateTranslation = getConnectedElementCoordinateTranslation({
        connectedElementPosition: connectedElementPosition,
        lineElementPosition: lineElementPosition
    });
    return pointLib.scale(gridSize, lineElementCoordinateTranslation);
};

var getConnectedElementRect = function getConnectedElementRect(_ref5) {
    var lineEdge = _ref5.lineEdge,
        connectedElementMeasurements = _ref5.connectedElementMeasurements,
        connectedElementTranslation = _ref5.connectedElementTranslation;

    if (!isLineEdgeSnapped(lineEdge) || !connectedElementTranslation || !connectedElementMeasurements) return null;

    return rectLib.getRect(_extends({}, connectedElementTranslation, connectedElementMeasurements));
};

var getMeasurementsConnectionOrigin = (0, _immutableHelper.prop)('originOffset');

var getTranslatedMeasurementsConnectionOrigin = function getTranslatedMeasurementsConnectionOrigin(_ref6) {
    var connectedElementMeasurements = _ref6.connectedElementMeasurements,
        connectedElementTranslation = _ref6.connectedElementTranslation;

    var connectionOrigin = getMeasurementsConnectionOrigin(connectedElementMeasurements);
    return pointLib.translate(connectedElementTranslation, connectionOrigin);
};

var getLineEdgeConnectionOrigin = function getLineEdgeConnectionOrigin(_ref7) {
    var lineEdge = _ref7.lineEdge,
        connectedElementMeasurements = _ref7.connectedElementMeasurements,
        connectedElementTranslation = _ref7.connectedElementTranslation,
        gridSize = _ref7.gridSize;
    return !isLineEdgeSnapped(lineEdge) || !connectedElementMeasurements ? getUnsnappedCoordinates(lineEdge, gridSize) : getTranslatedMeasurementsConnectionOrigin({ connectedElementMeasurements: connectedElementMeasurements, connectedElementTranslation: connectedElementTranslation });
};

var getEdgeOriginAndRect = exports.getEdgeOriginAndRect = function getEdgeOriginAndRect(_ref8) {
    var lineEdge = _ref8.lineEdge,
        measurementsMap = _ref8.measurementsMap,
        connectedElementPosition = _ref8.connectedElementPosition,
        lineElementPosition = _ref8.lineElementPosition,
        gridSize = _ref8.gridSize;

    var connectedElementTranslation = getScaledConnectedElementCoordinateTranslation({
        connectedElementPosition: connectedElementPosition,
        lineElementPosition: lineElementPosition,
        gridSize: gridSize
    });

    var connectedElementMeasurements = getConnectedElementMeasurements({ lineEdge: lineEdge, measurementsMap: measurementsMap });

    var rect = getConnectedElementRect({
        lineEdge: lineEdge,
        connectedElementMeasurements: connectedElementMeasurements,
        connectedElementTranslation: connectedElementTranslation
    });
    var origin = getLineEdgeConnectionOrigin({
        lineEdge: lineEdge,
        connectedElementMeasurements: connectedElementMeasurements,
        connectedElementTranslation: connectedElementTranslation,
        gridSize: gridSize
    });

    return {
        origin: origin,
        rect: rect
    };
};

/**
 * Finds the point at which the line visibly originates from.
 * This is either the origin if there's no 'source perimeter' or a point along the perimeter that the line
 * intersects with.
 */
var getVisibleConnectionPoint = exports.getVisibleConnectionPoint = function getVisibleConnectionPoint(_ref9) {
    var sourcePoint = _ref9.sourcePoint,
        controlPoint = _ref9.controlPoint,
        targetPoint = _ref9.targetPoint,
        sourcePerimeter = _ref9.sourcePerimeter;
    return !sourcePerimeter ? sourcePoint : (0, _bezierUtil.rectBezierIntersection)(sourcePerimeter, { sourcePoint: sourcePoint, controlPoint: controlPoint, targetPoint: targetPoint }) || null;
};

var getLinePointsOfInterest = exports.getLinePointsOfInterest = function getLinePointsOfInterest(_ref10) {
    var startEdgeOrigin = _ref10.startEdgeOrigin,
        startConnectionRect = _ref10.startConnectionRect,
        endEdgeOrigin = _ref10.endEdgeOrigin,
        endConnectionRect = _ref10.endConnectionRect,
        controlPoint = _ref10.controlPoint;

    var _controlPoint = (0, _lineControlPointUtil.snapControlPointIfClose)({ controlPoint: controlPoint, startEdgeOrigin: startEdgeOrigin, endEdgeOrigin: endEdgeOrigin });

    // Use the line connecting from the end to the centre point of the start rect.
    var startVisibleConnectionPoint = getVisibleConnectionPoint({
        sourcePoint: startEdgeOrigin,
        controlPoint: _controlPoint,
        targetPoint: endEdgeOrigin,
        sourcePerimeter: startConnectionRect
    });
    var endVisibleConnectionPoint = getVisibleConnectionPoint({
        sourcePoint: endEdgeOrigin,
        controlPoint: _controlPoint,
        targetPoint: startEdgeOrigin,
        sourcePerimeter: endConnectionRect
    });

    var isControlPointWithinAnElement = rectLib.containsPoint(startConnectionRect, _controlPoint) || rectLib.containsPoint(endConnectionRect, _controlPoint);

    if (startVisibleConnectionPoint && endVisibleConnectionPoint) {
        var originLineMidpoint = (0, _lineControlPointUtil.getHalfwayPoint)(startEdgeOrigin, endEdgeOrigin);

        // If the connected elements are overlapping each other and the line isn't being curved around them
        if (rectLib.isOverlapping(startConnectionRect, endConnectionRect) && isControlPointWithinAnElement) {
            return { start: {}, end: {} };
        } else if (isControlPointWithinAnElement || pointLib.equals(originLineMidpoint, _controlPoint)) {
            // If the control point is equal to the midpoint of the line, then make it the midpoint of the two
            // visible connections
            _controlPoint = (0, _lineControlPointUtil.getHalfwayPoint)(startVisibleConnectionPoint, endVisibleConnectionPoint);
        }
    }

    return {
        start: startVisibleConnectionPoint,
        end: endVisibleConnectionPoint,
        startEdgeOrigin: startEdgeOrigin,
        endEdgeOrigin: endEdgeOrigin,
        startConnectionRect: startConnectionRect,
        endConnectionRect: endConnectionRect,
        controlPoint: _controlPoint
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/line/lineUtil.js
// module id = 201
// module chunks = 0